/* SEELENHAUCH Contact FAQ enhancement
   Native <details> remains functional without JavaScript.
*/
(() => {
  const roots = document.querySelectorAll('[data-sh-contact-faq]');
  if (!roots.length) return;

  roots.forEach((root) => {
    const items = root.querySelectorAll('.sh-contact-faq__item');

    items.forEach((item) => {
      item.addEventListener('toggle', () => {
        if (!item.open) return;

        items.forEach((other) => {
          if (other !== item && other.open) {
            other.open = false;
          }
        });
      });
    });
  });
})();
